
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rubriken/[slug]",
      function () {
        return require("private-next-pages/rubriken/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rubriken/[slug]"])
      });
    }
  